import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import ReportCard from "../components/ui/ReportCard";
import MwCardWrapper from "../components/ui/MwCardWrapper";
import { useNavigate } from "react-router-dom";

export const Reports = () => {
  const { t } = useTranslation("global");
  const isArabic = i18next.dir(i18next.language) === "rtl";
  const navigate = useNavigate();
  const reports = [
    {
      id: "general-ledger",
      titleAr: t("reportsList.generalLedger.titleAr"),
      titleEn: t("reportsList.generalLedger.titleEn"),
      descriptionAr: t("reportsList.generalLedger.description"),
      icon: "/assets/icons/ledger.png",
      badge: "bg-pink-100 text-pink-800",
      onClick: () => navigate("account-status"),
      index: 0,
    },
    {
      id: "trial-balance",
      titleAr: t("reportsList.trialBalance.titleAr"),
      titleEn: t("reportsList.trialBalance.titleEn"),
      descriptionAr: t("reportsList.trialBalance.description"),
      icon: "/assets/icons/balance.png",
      badge: "bg-blue-100 text-blue-800",
      onClick: () => navigate("trial-balance"),
      index: 1,
    },
    {
      id: "income-statement",
      titleAr: t("reportsList.incomeStatement.titleAr"),
      titleEn: t("reportsList.incomeStatement.titleEn"),
      descriptionAr: t("reportsList.incomeStatement.description"),
      icon: "/assets/icons/evaluation.png",
      badge: "bg-green-100 text-green-800",
      onClick: () => console.log("Income Statement"),
      index: 2,
    },

    {
      id: "balance-sheet",
      titleAr: t("reportsList.balanceSheet.titleAr"),
      titleEn: t("reportsList.balanceSheet.titleEn"),
      descriptionAr: t("reportsList.balanceSheet.description"),
      icon: "/assets/icons/balance-sheet.png",
      badge: "bg-purple-100 text-purple-800",
      onClick: () => console.log("Balance Sheet"),
      index: 3,
    },
  ];

  return (
    <MwCardWrapper>
      <div className="p-6">
        {/* Header */}
        <div className="mb-8 mt-5 text-center ">
          <h1 className="text-3xl font-bold text-[#261759] mb-2">
            {t("reportsList.title")}
          </h1>
          <p className="text-[#261759]/70">{t("reportsList.subtitle")}</p>
        </div>

        {/* Reports Grid */}
        <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-4 gap-4">
          {reports.map((report, index) => (
            <ReportCard index={index} key={report.id} {...report} />
          ))}
        </div>
      </div>
    </MwCardWrapper>
  );
};
